import { DoctorOverallRegistrationStatus } from 'common/enum/doctor-overall-registration-status'
import { DoctorRegistrationSteps } from 'common/enum/doctor-overall-registration-steps'

export type DoctorOverall = {
  step: DoctorRegistrationSteps
  status: DoctorOverallRegistrationStatus
  description?: string
}

export type OverallRegistrationStatusModel = {
  overall_registration_status_id: number
  doctorOverall: DoctorOverall[]
  createdAt?: Date
  updatedAt?: Date
}

export function translateRegistrationStepName(step: DoctorRegistrationSteps) {
  const translatedSteps = {
    [DoctorRegistrationSteps.ACADEMIC_EDUCATION]: 'Formação academica',
    [DoctorRegistrationSteps.ADDRESS]: 'Endereço',
    [DoctorRegistrationSteps.CONTACTS]: 'Contato',
    [DoctorRegistrationSteps.DOCUMENTS_AND_ATTACHMENTS]: 'Documentos e Anexos',
    [DoctorRegistrationSteps.IMUNNIZATION]: 'Imunização',
    [DoctorRegistrationSteps.MEDICAL_PRIVILEGES]: 'Privilégios Médicos',
    [DoctorRegistrationSteps.PERSONAL_DATA]: 'Dados Pessoais',
    [DoctorRegistrationSteps.PROFESSIONAL_DATA]: 'Dados Profissionais',
    [DoctorRegistrationSteps.SECTORS_OF_ACTIVITY]: 'Setores',
    [DoctorRegistrationSteps.TEAMS]: 'Equipes',
    [DoctorRegistrationSteps.ATTENDANCES]: 'Atendimentos',
    [DoctorRegistrationSteps.SPECIALTIES]: 'Especialidades',
    [DoctorRegistrationSteps.TERMS]: 'Termos',
    [DoctorRegistrationSteps.CNES]: 'CNES',
    [DoctorRegistrationSteps.SOURCE_VALIDATION]: 'Validação da fonte',
    default: ''
  }
  return translatedSteps[step] || translatedSteps['default']
}
